import { useEffect, useRef, useState } from 'react';
import { useNavigate, useParams, useLocation, Link } from 'react-router-dom';
import { createCourseDraft, editCourseDraft } from './infra/repository/CourseDraftRepository';

export default function StartCourseDraft() {
  const { courseId } = useParams();
  const navigate = useNavigate();
  const fresh = new URLSearchParams(useLocation().search).get('fresh') === 'true';
  const operation = useRef(null);
  const [error, setError] = useState('');
  useEffect(() => {
    let active = true;
    if (operation.current?.courseId !== courseId || operation.current?.fresh !== fresh) {
      operation.current = { courseId, fresh, promise: courseId ? editCourseDraft(courseId, fresh) : createCourseDraft() };
    }
    operation.current.promise.then(draft => {
      if (active) return navigate(`/editor/course-drafts/${draft.id}`, { replace: true });
    }).catch(() => { if (active) setError('Unable to open a course draft. Please try again.'); });
    return () => { active = false; };
  }, [courseId, fresh, navigate]);
  return <main className="course-editor">
    {error ? <><p role="alert">{error}</p><Link to="/editor/course-drafts">Back to course drafts</Link></> : <p><output>Opening course draft…</output></p>}
  </main>;
}
